// states/useHomeState.js
import { useState } from "react";

export const useHomeState = () => {
  const [matches, setMatches] = useState([]);
  const [currentLiveMatchIndex, setCurrentLiveMatchIndex] = useState(0);
  const [season, setSeason] = useState(new Date().getFullYear().toString());
  const [matchesLoading, setMatchesLoading] = useState(true);
  const [newsData, setNewsData] = useState([]);
  const [homeData, setHomeData] = useState([]);
  const [sponsorData, setSponsorData] = useState([]);
  const [sponsorAds, setSponsorAds] = useState([]);
  const [featuredMatches, setFeaturedMatches] = useState([]);
  const [pointsTableData, setPointsTableData] = useState([]);
  const [foundLeague, setFoundLeague] = useState({});
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("completed");
  const [currentAdIndex, setCurrentAdIndex] = useState(0);
  const [liveResults, setLiveResults] = useState([]);
  const [liveResultsLoading, setLiveResultsLoading] = useState(false);
  const [leagueCommitteeMembers, setLeagueCommitteeMembers] = useState([]);
  const [winningTeams, setWinningTeams] = useState([]);
  const [manOfTheMatchList, setManOfTheMatchList] = useState([]);
  const [umpireDetails, setUmpireDetails] = useState([]);
  const [aboutLeagueDetails, setAboutLeagueDetails] = useState([]);
  const [homeVideo, setHomeVideo] = useState(null);

  return {
    matches,
    setMatches,
    currentLiveMatchIndex,
    setCurrentLiveMatchIndex,
    season,
    setSeason,
    matchesLoading,
    setMatchesLoading,
    newsData,
    setNewsData,
    homeData,
    setHomeData,
    sponsorData,
    setSponsorData,
    sponsorAds,
    setSponsorAds,
    featuredMatches,
    setFeaturedMatches,
    pointsTableData,
    setPointsTableData,
    foundLeague,
    setFoundLeague,
    teams,
    setTeams,
    loading,
    setLoading,
    activeTab,
    setActiveTab,
    currentAdIndex,
    setCurrentAdIndex,
    liveResults,
    setLiveResults,
    liveResultsLoading,
    setLiveResultsLoading,
    leagueCommitteeMembers,
    setLeagueCommitteeMembers,
    winningTeams,
    setWinningTeams,
    manOfTheMatchList,
    setManOfTheMatchList,
    umpireDetails,
    setUmpireDetails,
    aboutLeagueDetails,
    setAboutLeagueDetails,
    homeVideo,
    setHomeVideo,
  };
};